import { common } from "./common";
import { error } from "./error";
import { user } from "./user";
import { plan } from "./plan";
import { technical } from "./technical";
import { form } from "./form";
import { question } from "./question";
import { method } from "./method";
import { evaluation } from "./evaluation";
import { analysis } from "./analysis";
import { employee } from "./employee";
import { date } from "./date";
import { report } from "./report";
import { equipment } from "./equipment";
import { result } from "./result";

export const language = {
    translations: {
        common,
        equipment,
        error,
        user,
        plan,
        technical,
        form,
        question,
        method,
        evaluation,
        analysis,
        employee,
        date,
        report,
        result,
    },
};